import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./play.scss"
import { useState } from "react";
export const VideoJS = (props: any) => {
  let activityTimer: any = null
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady } = props;
  const [active, setActive] = useState(true);
  const inactivityThreshold = 60000; // 1 分钟

  //禁止拖拽事件
  const disabledProgressControl = (player: any) => {
    const progressControl = player.controlBar.progressControl;
    progressControl.disable();
  }
  //防挂机事件
  const disableMachine = (player: any) => {
    const handleInactivity = () => {
      console.log('防挂机啦')
      player.pause();
    };
    // activityTimer = setTimeout(() => {
    //   debugger
    //   if (active) {
    //     handleActivity();
    //   } else {
    //     handleInactivity();
    //   }
    // }, inactivityThreshold);
    player.on('userinactive', handleInactivity);
  }
  React.useEffect(() => {
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;
      const { sources, height } = options
      const player: any = playerRef.current = videojs(videoElement, {
        ...options,
        fluid: true,
        width: '100%',
        inactivityTimeout:5000,//防挂机时间限制
        height: height || 400, // 默认高度设置为 400
      }, () => { //挂载视频组件完成
      
        // player.currentTime(100);   //设置播放进度
        // disabledProgressControl(player) //禁止拖拽进度条
        // disableMachine(player) //防挂机事件
        const controlBar = player.controlBar;
        const qualityButton = videojs.dom.createEl('button', {
          className: 'vjs-quality-button vjs-control vjs-button',
          innerHTML: '清晰度',
        });
        const qualityMenu = videojs.dom.createEl('div', {
          className: 'vjs-menu',
        });
        sources.forEach((source: any, index: number) => {
          const menuItem = videojs.dom.createEl('div', {
            className: 'vjs-menu-item',
            innerHTML: source.label,
          });
          menuItem.addEventListener('click', () => {
            player.src(source);
            player.play();
          })
          qualityMenu.appendChild(menuItem);
          qualityButton.appendChild(qualityMenu);
          controlBar.el().insertBefore(qualityButton, controlBar.children()[controlBar.children().length - 1].el());
          const style = document.createElement('style');
          style.innerHTML = `
          .vjs-quality-button {
            position: relative;
          }
          .vjs-menu {
            display: none;
            position: absolute;
            bottom: 30px;
            background: rgba(0, 0, 0, 0.75);
          }
          .vjs-quality-button:hover .vjs-menu {
            display: block;
          }
          .vjs-menu-item {
            padding: 10px;
            cursor: pointer;
          }
          .vjs-menu-item:hover {
            background: rgba(255, 255, 255, 0.1);
          }
          .vjs-pause-overlay {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 3em;
            color: white;
            z-index: 10;
          }
          .vjs-paused .vjs-pause-overlay {
            display: block;
          }
          `;
          document.head.appendChild(style);
        });
        onReady && onReady(player);
      });
    } else {
      // you can update player here [update player through props]
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef]);



  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;
    return () => {
      if (activityTimer) {
        clearTimeout(activityTimer);
      }
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player className="video-container" style={{ width: "100%", height: "400px", paddingTop: "0", margin: "80px auto" }}>
      <video ref={videoRef} className="video-js vjs-big-play-centered vjs-default-skin" />
    </div>
  );
}

export default VideoJS;
